import $ from 'jquery';
import 'velocity-animate';

import config from './globals/config';

export default function (body, trailersSlicesB, headerLi, footerLi, videoCont, area, areaRatio) {
  function calPx (e) {
    clearTimeout(config.trailerSlicesInterval);

    if (config.isIntroDone) {
      body.addClass('move');

      if (config.isReady) {
        config.isReady = false;

        let nonActiveSlices = $('.trailers-scroll li:not(.active) a');
        let activeSlice = $('.trailers-scroll .active').find('a');

        headerLi.velocity('top-bar-intro');

        nonActiveSlices.velocity('trailers-slices-enter', {
          complete: function () {
            // once the slices animate out of the way, scale up vid
            videoCont.velocity('homepage-video-enter');
          },
        });

        activeSlice.velocity('trailers-slices-active-enter');
        footerLi.velocity('footer-intro');
      }
    }

    setRemoveTimer(2500);

    let mousePos = e.pageX - body[0].offsetLeft;
    config.mousePosMod = Math.min(Math.max(0, mousePos - config.mouseMovePadding), area) * areaRatio;
    e.preventDefault();
  }

  body.mousemove(function (e) {
    if (config.isIntroDone) {
      calPx(e, false);
    }
  });

  setRemoveTimer(2000);

  function setRemoveTimer (time) {
    config.trailerSlicesInterval = setTimeout(function () {
      // dont remove if search being used
      if (!$('.search-input-container').hasClass('search-open')) {
        removeMove();
      }
    }, time);
  }

  function removeMove () {
    body.removeClass('move');

    let nonActiveSlices = $('.trailers-scroll li:not(.active) a');
    let activeSlice = $('.trailers-scroll .active').find('a');

    headerLi.velocity('top-bar-exit');

    nonActiveSlices.velocity('trailers-slices-exit', {
      complete: function () {
        videoCont.velocity('homepage-video-exit', {
          complete: function () {
            config.isReady = true;
          },
        });
      },
    });

    activeSlice.velocity('trailers-slices-active-exit', {
      complete: function () {
        config.isReady = true;
      },
    });

    footerLi.velocity('footer-exit');
  }
}
